import 'babel-polyfill';
import EdlioForm from './classes/form';
import initializeSentry from '../../../../common/edlio-js/utils/initializeSentry';
import captureMessage from './utils/captureMessage';

(function(window, document) {
  // Element.remove polyfill
  if (!('remove' in Element.prototype)) {
    Element.prototype.remove = function() {
      if (this.parentNode) {
        this.parentNode.removeChild(this);
      }
    };
  }

  window.addEventListener('DOMContentLoaded', () => {
    const {
      navigator: {
        userAgent
      },
      edlio: {
        sentryDsn,
        serverId,
        isDevelopmentServer
      }
    } = window;

    const responseData = JSON.parse(sessionStorage.getItem('edlioFormEditResponseData'));
    const responseId = responseData ? responseData.responseId : '';
    const form = new EdlioForm(window.edlio.formData, responseId);

    if (responseData) {
      form.enableEditMode();
      form.populate(responseData);
      sessionStorage.removeItem('edlioFormEditResponseData');
    }

    initializeSentry(
      sentryDsn,
      serverId, 
      isDevelopmentServer.toString(),
      (event) => event.extra && event.extra.sentInternally ? event : null
    )

    if(window.edlio.formUI.isRendered)
      form.initialize(userAgent);
  });

  // Reload form page if page was loaded from browser cache(with some prefilled form data)
  window.addEventListener('pageshow', function(event) {
      if (event.persisted || (window.performance && window.performance.navigation.type === 2)) {
        location.reload(true);
      }
    });
  })(window, document);



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/public/app.js